export class CarInfoInputErrorMessageModel {

    /** メーカーのエラーメッセージ */
    makerErrorMsg: string = "";
    /** 車種のエラーメッセージ */
    typeErrorMsg: string = "";
    /** 運輸支局のエラーメッセージ */
    transportBranchOfficeErrorMsg: string = "";
    /** 分類番号のエラーメッセージ */
    classNumberErrorMsg: string = "";
    /** ひらがなのエラーメッセージ */
    hiraganaErrorMsg: string = "";
    /** 一連指定番号のエラーメッセージ */
    serialNumberErrorMsg: string = "";
    /** 前手動入力のエラーメッセージ */
    frontFreeInputErrorMsg: string = "";
    /** 後手動入力のエラーメッセージ */
    reaFreeInputErrorMsg: string = "";

    public reset() {
        // メッセージを初期化
        this.makerErrorMsg = "";
        this.typeErrorMsg = "";
        this.transportBranchOfficeErrorMsg = "";
        this.classNumberErrorMsg = "";
        this.hiraganaErrorMsg = "";
        this.serialNumberErrorMsg = "";
        this.frontFreeInputErrorMsg = "";
        this.reaFreeInputErrorMsg = "";
    }
}